import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const COOKIE_KEY = "digiponto_cookies_accepted_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(COOKIE_KEY);
      if (!accepted) setVisible(true);
    } catch { setVisible(true); }
  }, []);

  const accept = () => {
    try { localStorage.setItem(COOKIE_KEY, new Date().toISOString()); } catch {}
    setVisible(false);
  };

  if (!visible || window.location.pathname.startsWith("/kiosk/")) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[70] bg-slate-900 text-white rounded-2xl shadow-2xl border border-slate-700/60 p-4 flex items-start gap-3"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      data-testid="cookie-banner"
    >
      <div className="h-9 w-9 shrink-0 rounded-full bg-emerald-500/15 text-emerald-300 grid place-items-center">
        <Cookie size={18} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold">Este site usa cookies</div>
        <p className="text-xs text-slate-300 mt-0.5 leading-relaxed">
          Utilizamos cookies essenciais para manter sua sessão de login e lembrar
          preferências de uso. Ao continuar navegando, você concorda com nossa
          política de privacidade conforme a <strong>LGPD</strong>.
        </p>
        <div className="mt-3 flex items-center gap-2">
          <button
            type="button"
            onClick={accept}
            data-testid="btn-accept-cookies"
            className="h-9 px-4 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold transition"
          >
            Aceitar e continuar
          </button>
          <a
            href="/politica-privacidade"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="link-privacy-policy"
            className="h-9 px-3 rounded-lg text-xs font-semibold text-slate-300 hover:text-white inline-flex items-center transition"
          >
            Saiba mais
          </a>
        </div>
      </div>
      <button
        type="button"
        onClick={accept}
        aria-label="Fechar aviso de cookies"
        data-testid="btn-close-cookies"
        className="h-7 w-7 shrink-0 grid place-items-center rounded-md text-slate-400 hover:text-white hover:bg-slate-800 transition"
      >
        <X size={14} />
      </button>
    </div>
  );
}
